
/**
 * This service provides user management functions for GoTrue cloud service from Netlify.
 */

import axios from 'axios'
import { FunctionUrl } from 'config/auth' // audience

import { getJWT, register } from './auth'

export const listUsers = ({ page = 1 }) => {
  return axios.get(`${FunctionUrl}/.netlify/functions/identity-admin/users/${page}`, {
    headers: { Authorization: "Bearer: " + getJWT() }
  })
}

export const getUserById = ({ id }) => {
  return axios.get(`${FunctionUrl}/.netlify/functions/identity-admin/user/${id}`, {
    headers: { Authorization: "Bearer: " + getJWT() }
  })
}

export const updateUserById = ({ id, attributes = {} }) => {
  return axios.put(
    `${FunctionUrl}/.netlify/functions/identity-admin/update/${id}`, 
    attributes, { headers: { Authorization: "Bearer: " + getJWT() } }
  )
}

export const createUser = ({ email, password, attributes = {} }) => {
  return register({ email, password, data: attributes })
  // attributes.email = email
  // attributes.password = password
  // return axios.post(`${FunctionUrl}/.netlify/functions/identity-admin/create`, 
  //   attributes, { headers: { Authorization: "Bearer: " + getJWT() } }
  // )
}

export const deleteUserById = ({ id }) => {
  return axios.delete(`${FunctionUrl}/.netlify/functions/identity-admin/delete/${id}`, {
    headers: { Authorization: "Bearer: " + getJWT() }
  })
}
